import { Box, Typography, Button, Link } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";

const RealEstateMarketplace = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      m="40px auto"
      p="30px"
      maxWidth="800px"
      border="2px solid #E5E8E8"
      borderRadius="12px"
      boxShadow="0px 4px 10px rgba(0, 0, 0, 0.1)"
      backgroundColor={colors.primary[900]}
    >
      {/* Back Button */}
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        sx={{ color: "colors.primary[200]", mb: 3, fontWeight: "bold" }}
      >
        Back
      </Button>

      {/* Project Title */}
      <Typography
        variant="h3"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={2}
      >
        <Link
          // href="https://main.der6iucjh9n4k.amplifyapp.com/"
          target="_blank"
          underline="none"
          color="inherit"
          sx={{
            textDecoration: "none",
            px: 1,
            borderRadius: 1,
            transition: "background-color 0.3s",
            "&:hover": {
              backgroundColor: "grey.300",
              cursor: "pointer",
            },
          }}
        >
          Real Estate Marketplace
        </Link>
      </Typography>

      {/* Project Description */}
      <Typography variant="h5" color={colors.primary[200]} mb={3}>
        A real estate marketplace to view properties, post and find rental properties. 
      </Typography>

      {/* Technical Challenges */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technical Challenges:
      </Typography>
      <Box component="ul" color={colors.primary[200]} mb={3}>
        <li>
          Authentication and design for multiple users and user views
          (Tenant/Property Owner).
        </li>
        <li>Server side data filtering</li>
        <li>Reduce latency when fetching data</li>
      </Box>

      {/* Tech Stack */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Technical Stack:
      </Typography>
      <Typography
        variant="h6"
        fontStyle="italic"
        color={colors.primary[200]}
        mb={1}
      >
        FrontEnd: Next.js, Redux, Typescript, TailwindCSS, Shadcn,
        Framer-Motion, react-hook-form, Zod
        <br />
        BackEnd: Node.js, Express.js, AWS EC2, API Gateway, RDS, S3, Amplify
        <br />
        Authentication: AWS Cognito
      </Typography>

      {/* Wireframe Section */}
      {/* <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Wireframe:
      </Typography>
      <Box
        height="200px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        border="2px dashed #AAB7B8"
        borderRadius="8px"
        mb={3}
      >
        <Typography color="#839192">Wireframe Placeholder</Typography>
      </Box> */}

      {/* Demo Section */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color={colors.primary[200]}
        mb={1}
      >
        Demo:
      </Typography>
      <Box
        height="200px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        border="2px dashed #AAB7B8"
        borderRadius="8px"
      >
        <Typography color="#839192">Demo Placeholder</Typography>
      </Box>
    </Box>
  );
};

export default RealEstateMarketplace;
